import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { motion } from "framer-motion";

const FAQ = ({ faqs, title = "Got Questions?" }) => {
  return (
    <Box sx={{ maxWidth: "700px", margin: "0 auto", padding: "30px 20px" }}>
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            mb: 4,
            textAlign: "center",
            color: "#333",
            letterSpacing: "0.5px",
          }}
        >
          {title}
        </Typography>
      </motion.div>

      {faqs.map((faq, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1, duration: 0.4 }}
        >
          <Accordion
            sx={{
              mb: 2,
              borderRadius: "12px",
              boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.1)",
              background: `linear-gradient(135deg, #f8f9fa 0%, #f1f3f5 100%)`,
              "&:hover": {
                boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.15)",
              },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: "#ff5722" }} />}
              sx={{
                backgroundColor: "#fff",
                borderRadius: "12px",
                padding: "10px 20px",
              }}
            >
              <Typography variant="body1" sx={{ fontWeight: 600 }}>
                {faq.question}
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                backgroundColor: "#fafafa",
                padding: "15px 20px",
                borderBottomLeftRadius: "12px",
                borderBottomRightRadius: "12px",
              }}
            >
              <Typography
                variant="body2"
                sx={{ color: "#666", lineHeight: 1.6 }}
              >
                {faq.answer}
              </Typography>
            </AccordionDetails>
          </Accordion>
        </motion.div>
      ))}
    </Box>
  );
};

export default FAQ;
